import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Spinner from './Spinner.jsx'

function QuoteResultLaraLink({
  currentCurrency,
  rates,
  isLoading,
  quote,
  isAiQuoteEnabled,
  labelType,
}) {
  if (isLoading) {
    return (
      <div className="quote-result quote-result--lara-link quote-result--loading">
        <Spinner />
      </div>
    )
  }

  const laraLinkUrl = 'https://lara.translated.com'

  return (
    <div className="quote-result quote-result--lara-link">
      <div className="quote-result__header">
        <h4>{i18n.t('Components.QuoteResultLaraLink.title', { defaultValue: 'AI Translation' })}</h4>
      </div>
      <div className="quote-result__body">
        <p>{i18n.t('Components.QuoteResultLaraLink.description', { defaultValue: 'Try our AI-powered translation service' })}</p>
      </div>
      <div className="quote-result__footer">
        <a 
          href={laraLinkUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          className="button button--secondary"
        >
          {i18n.t('Components.QuoteResultLaraLink.cta', { defaultValue: 'Try Lara' })}
        </a>
      </div>
    </div>
  )
}

QuoteResultLaraLink.propTypes = {
  currentCurrency: PropTypes.string.isRequired,
  rates: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  quote: PropTypes.object,
  isAiQuoteEnabled: PropTypes.bool,
  labelType: PropTypes.string,
}

export default QuoteResultLaraLink
